import React from "react";
import { useTransition } from "react-spring";
import { TransitionContainer } from "../TransitionContainer/styles";
import * as S from "./styles";
var customConfig = {
  mass: 1,
  tension: 120,
  friction: 50,
  precision: 1e-4
};
export function Slide(_ref) {
  var t = _ref.image,
      e = _ref.imageAlt,
      n = _ref.eyebrow,
      a = _ref.title,
      i = _ref.copy,
      o = _ref.subtitle,
      s = _ref.activeSlide,
      r = _ref.direction;
  var c = {
    config: Object.assign(Object.assign({}, customConfig), {
      friction: .5 * customConfig.friction
    }),
    from: {
      transform: "right" === r ? "translate3d(-100%, 0, 0)" : "translate3d(100%, 0, 0)",
      opacity: -5
    },
    enter: {
      transform: "translate3d(0%, 0, 0)",
      opacity: 1,
      position: "static",
      delay: 200
    },
    leave: {
      transform: "right" === r ? "translate3d(100%, 0, 0)" : "translate3d(-100%, 0, 0)",
      opacity: 0,
      position: "absolute"
    },
    key: s
  },
      l = useTransition(a, c),
      m = useTransition(n, c),
      f = useTransition(i, Object.assign(Object.assign({}, c), {
    config: Object.assign(Object.assign({}, customConfig), {
      friction: .7 * customConfig.friction
    }),
    leave: {
      transform: "right" === r ? "translate3d(100%, 0, 0)" : "translate3d(-100%, 0, 0)",
      opacity: 0,
      position: "absolute",
      left: 0,
      top: 0
    }
  })),
      g = useTransition(o, Object.assign(Object.assign({}, c), {
    config: Object.assign(Object.assign({}, customConfig), {
      friction: .8 * customConfig.friction
    }),
    leave: {
      transform: "right" === r ? "translate3d(100%, 0, 0)" : "translate3d(-100%, 0, 0)",
      opacity: 0,
      position: "absolute",
      left: 0
    }
  })),
      u = useTransition(t, {
    config: Object.assign(Object.assign({}, customConfig), {
      friction: .9 * customConfig.friction
    }),
    from: {
      transform: "right" === r ? "translate3d(-125%, 0, 0)" : "translate3d(125%, 0, 0)"
    },
    enter: {
      transform: "translate3d(0%, 0, 0)",
      delay: 200,
      position: "static"
    },
    leave: {
      transform: "right" === r ? "translate3d(125%, 0, 0)" : "translate3d(-125%, 0, 0)",
      position: "absolute"
    },
    key: s
  });
  return React.createElement(S.Slide, null, React.createElement(S.ImageContainer, null, u(function (t, n, a) {
    return "object" == typeof n ? React.createElement(S.ImageComponentContainer, {
      key: a,
      style: t
    }, n) : React.createElement(S.Image, {
      key: a,
      style: t,
      alt: e,
      src: n
    });
  })), React.createElement(S.ContentContainer, null, n ? React.createElement(TransitionContainer, null, m(function (t, e) {
    return React.createElement(S.EyebrowDesktop, {
      style: t
    }, e);
  })) : null, React.createElement(S.TitleTransitionContainer, null, l(function (t, e) {
    return React.createElement(S.Title, {
      style: t
    }, e);
  })), React.createElement(TransitionContainer, null, f(function (t, e) {
    return React.createElement(S.Paragraph, {
      style: t
    }, e);
  })), React.createElement(TransitionContainer, null, g(function (t, e) {
    return React.createElement(S.Subtitle, {
      style: t
    }, e);
  }))));
}
export default Slide;